import { render, staticRenderFns } from "./orderDetails_Com.vue?vue&type=template&id=5675ce05&scoped=true&"
import script from "./orderDetails_Com.vue?vue&type=script&lang=js&"
export * from "./orderDetails_Com.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails_Com.vue?vue&type=style&index=0&id=5675ce05&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675ce05",
  null
  
)

export default component.exports